import { render, staticRenderFns } from "./PrivacyPolicyNew.vue?vue&type=template&id=604edf3d"
import script from "./PrivacyPolicyNew.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports